//Dropzone component for receipt upload step. Appears in a modal.
import React from 'react'
import { useDropzone } from 'react-dropzone'
import { useTranslation } from 'i18n'

const ReceiptDropzoneButton = ({
  onError,
  onUpload,
  className = 'btn',
  label,
  disabled = undefined,
}) => {
  const { t } = useTranslation('receipt')
  const { acceptedFiles, fileRejections, getRootProps, getInputProps } =
    useDropzone({
      maxFiles: 4,
      accept: { 'image/*': [] },
      multiple: true,
      minSize: 1024,
      maxSize: 10 * 1024 * 1024, // 10mb(!!)
      onDropAccepted: files => {
        onError()
        onUpload(files)
      },
      onDropRejected: files => {
        let errors = files.map(file => file.errors[0].code).join(' ')
        onError(
          errors.includes('file-too-large'),
          errors.includes('file-invalid-type'),
          errors.includes('too-many-files')
        )
      },
    })

  if (fileRejections.length > 0) {
    let errors = fileRejections.map(file => file.errors[0].code).join(' ')
    onError(
      errors.includes('file-too-large'),
      errors.includes('file-invalid-type'),
      errors.includes('too-many-files')
    )
  }

  return (
    <div className={`receipt-upload-button`}>
      <div {...getRootProps({ className: `dropzone ` })}>
        <input {...getInputProps()} />
        <button className={`${className}`} disabled={disabled}>
          <span>{label || t('uploadCta')}</span>
        </button>
      </div>
    </div>
  )
}

export default ReceiptDropzoneButton
